<template>
  <div
    class="m-auto max-w-md px-6 md:my-4 md:mt-32 md:rounded-md md:border md:border-light-gray md:px-14 md:py-10 md:shadow-primary lg:mt-14"
    :class="customClass"
  >
    <div class="mb-10 flex justify-center">
      <img
        v-if="showLogo"
        class="h-6"
        src="@/assets/highway_logo.svg"
        alt="highway logo"
      />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Layout',
  props: {
    showLogo: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
/* @media screen and (min-width: 768px) {
  .tabletWidth {
    max-width: 458px;
  }
} */
</style>
